<template>
  <Spinner v-if="store.loading" />
  <div v-if="store.error" class="notification--error">{{ errorMessage }}</div>

  <div v-if="!store.loading && !store.error">
    <TransitionGroup appear name="fade">
      <PreviousStep v-for="(step, index) in store.previousSteps" :key="step.id" :step="step" :index="index" />
    </TransitionGroup>

    <Step v-if ="store.currentStep.stepType === StepType.Question || store.currentStep.stepType === StepType.Answer" />

    <Result v-if="store.currentStep.stepType === StepType.Result" />
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";
import { useWizardStepsService } from "./services/wizardStepsService";
import { useWizardStepsStore } from "./store/wizardStepsStore";
import { StepType } from "@features/Pages/WizardStepsPage/_js/App/types/stepType";
import Spinner from '@components/Spinner/Spinner.vue';
import PreviousStep from "@features/Pages/WizardStepsPage/_js/App/components/PreviousStep.vue";
import Step from './components/Step.vue';
import Result from "@features/Pages/WizardStepsPage/_js/App/components/Result.vue";

const store = useWizardStepsStore();
const wizardStepsService = useWizardStepsService()

const errorMessage = (document.getElementById("errorMessage") as HTMLInputElement).value;

onMounted(() => {
  wizardStepsService.getPageTree();
});
</script>